<template>
  <div class="flex-grow-1">
    <component :is="component" v-if="component" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Profile from './profile';
import Organization from './organization';
import Clan from './clan';
export default {
  name: 'ContactsWrapper',
  components: {
    Profile,
    Organization,
    Clan,
  },
  data() {
    return {
      // accountType: this.$route.params.accountType,
      // component: () => import('./' + this.accountType),
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountType']),
    // accountType() {
    //   return this.account && this.account._type;
    // },
    component() {
      return this.$lodash.upperFirst(this.accountType);
    },
    subheader() {
      return (
        this.account._name + ' ' + this.$lodash.upperFirst(this.account._type)
      );
    },
  },
};
</script>
